export enum Scene7Presets {
  ALT_MAIN = '$rr_altmain$',
  CART = '$rrs_cart$',
  COLOR = '$rr_color$',
  MAIN = '$rr_main$',
  SMALL_PDP = '$rrs_smallpdp$',
  ZOOM = '$rr_pdp_zoom$',
}
